<template>
  <div class="loginbBody">
    <div class="loginDiv">
      <div class="login-content">
        <h1 class="login-title">用户登录</h1>
        <el-form :model="loginForm"
                 label-width="100px"
                 :rules="rules"
                 ref="loginForm">
          <el-form-item label="用户名"
                        prop="name">
            <el-input style="width: 200px"
                      type="text"
                      v-model="loginForm.name"
                      autocomplete="off"
                      size="small"></el-input>
          </el-form-item>
          <el-form-item label="密码"
                        prop="password">
            <el-input style="width: 200px"
                      type="password"
                      v-model="loginForm.password"
                      show-password
                      autocomplete="off"
                      size="small"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       @click="confirm">确 定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      loginForm: {
        name: '111',
        password: '111'
      },
      rules: {
        name: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 10, message: '用户名长度在 3 到 6 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输密码', trigger: 'blur' },
          { min: 3, max: 6, message: '密码长度在 3 到 6 个字符', trigger: 'blur' }
        ]
      }

    }
  },
  methods: {
    confirm () {
      this.$refs.loginForm.validate((valid) => {
        if (valid) { // valid成功为true，失败为false
          // 去后台验证用户名密码，并返回token
          this.$axios.get('/server/fourG/menu/loginUser?jobNumber=' + this.loginForm.name + '&passWord=' + this.loginForm.password).then(res => {
            console.log(res.data)
            if (res.data === 1) {
              // 存储token到本地
              this.$store.commit('SET_TOKEN', res.data)
              // 跳转到主页
              this.$router.replace('/index')
            } else {
              alert('校验失败，用户名或密码错误！')
              return false
            }
          })
        } else {
          console.log('校验失败')
          return false
        }
      })
    }

  }
}
</script>

<style scoped >
.loginbBody {
  width: 100%;
  height: 100%;
  background-color: #b3c0d1;
}
.loginDiv {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -200px;
  margin-left: -250px;
  width: 450px;
  height: 330px;
  background: #fff;
  border-radius: 5%;
}
.login-title {
  margin: 20px 0;
  text-align: center;
}
.login-content {
  width: 400px;
  height: 250px;
  position: absolute;
  top: 25px;
  left: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/login/Login.vue